import { Box, Stack } from "@mui/material";
import { LoadingModalPayload } from "../types";
import { FC } from "react";
import { loadingModalDefaultProps } from "./defaultModalsProps";
import { PageLoader } from "@/src/components/Loaders";

export const ApiCallsLoadingModal: FC<Partial<LoadingModalPayload>> = ({
  title,
  description,
  disableClose,
  progress
}) => {
  const loadingTitle = title || loadingModalDefaultProps.title;
  const loadingDescription =
    description || loadingModalDefaultProps.description;

  return (
    <Box className="flex w-full max-w-96 flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal">
      <Stack className="flex flex-col gap-2 rounded-lg text-base text-dark-gray">
        <Box
          className={"flex flex-col items-center justify-center gap-3 p-6 pl-4"}
        >
          <PageLoader className="w-16 h-16" progress={progress}/>
          <Box className={"text-2xl font-semibold text-dark-gray text-center"}>
            {loadingTitle}
          </Box>
          <Box className={"text-base text-dark-gray text-center"}>{loadingDescription}</Box>
        </Box>
      </Stack>
    </Box>
  );
};
